import React, { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { User, Envelope, Phone, SignOut } from "@phosphor-icons/react";

export default function Profile() {
  const { user, loading, refresh, logout } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", last_name: "", email: "", phone: "" });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (loading) return;
    if (!user) { navigate("/connexion"); return; }
    setForm({ name: user.name || "", last_name: user.last_name || "", email: user.email || "", phone: user.phone || "" });
  }, [user, loading, navigate]);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.patch("/users/me", form);
      await refresh();
      toast.success("Profil mis à jour");
    } catch (err) { toast.error(err.response?.data?.detail || "Erreur"); } finally { setSaving(false); }
  };

  return (
    <Layout>
      <div className="max-w-xl mx-auto px-4 py-12">
        <h1 className="font-display text-3xl font-black text-stone-800" data-testid="profile-title">Mon profil</h1>
        <form onSubmit={save} className="mt-8 bg-white rounded-3xl border border-rose-100 p-8 space-y-5">
          <div className="grid sm:grid-cols-2 gap-3">
            <div>
              <Label className="flex items-center gap-2"><User size={16} /> Prénom</Label>
              <Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="rounded-2xl mt-1 py-6" data-testid="profile-name-input" />
            </div>
            <div>
              <Label className="flex items-center gap-2"><User size={16} /> Nom <span className="text-xs text-stone-400 font-normal">(privé)</span></Label>
              <Input value={form.last_name} onChange={(e) => setForm({ ...form, last_name: e.target.value })} className="rounded-2xl mt-1 py-6" data-testid="profile-lastname-input" />
            </div>
          </div>
          <div>
            <Label className="flex items-center gap-2"><Envelope size={16} /> Email</Label>
            <Input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="rounded-2xl mt-1 py-6" data-testid="profile-email-input" />
          </div>
          <div>
            <Label className="flex items-center gap-2"><Phone size={16} /> Téléphone (facultatif)</Label>
            <Input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className="rounded-2xl mt-1 py-6" placeholder="06 12 34 56 78" data-testid="profile-phone-input" />
          </div>
          <Button type="submit" disabled={saving} className="w-full bg-orange-500 hover:bg-orange-600 rounded-full py-6 font-bold shadow-lg shadow-orange-500/30" data-testid="profile-save-button">
            {saving ? "Enregistrement..." : "Enregistrer"}
          </Button>
        </form>

        <button onClick={async () => { await logout(); navigate("/"); }} className="mt-8 text-stone-500 hover:text-rose-600 font-bold text-sm flex items-center gap-2 mx-auto" data-testid="profile-logout-button">
          <SignOut size={18} /> Se déconnecter
        </button>
      </div>
    </Layout>
  );
}
